import { SVGProps } from "react";

function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(3.000000, 3.000000)">
          <mask id="transactions-mask" fill="white">
            <path d="M7.30993518,0.25 C8.2764335,0.25 9.05993518,1.03350169 9.05993518,2 L9.05993518,3.46566662 C9.05993518,3.60373781 9.171864,3.71566662 9.30993518,3.71566662 L16,3.71566662 C16.9664983,3.71566662 17.75,4.49916831 17.75,5.46566662 L17.75,15 C17.75,15.9664983 16.9664983,16.75 16,16.75 L2,16.75 C1.03350169,16.75 0.25,15.9664983 0.25,15 L0.25,2 C0.25,1.03350169 1.03350169,0.25 2,0.25 L7.30993518,0.25 Z M7.30993518,1.75 L2,1.75 C1.86192881,1.75 1.75,1.86192881 1.75,2 L1.75,15 C1.75,15.1380712 1.86192881,15.25 2,15.25 L16,15.25 C16.1380712,15.25 16.25,15.1380712 16.25,15 L16.25,5.46566662 C16.25,5.32759543 16.1380712,5.21566662 16,5.21566662 L9.30993518,5.21566662 C8.34343687,5.21566662 7.55993518,4.43216493 7.55993518,3.46566662 L7.55993518,2 C7.55993518,1.86192881 7.44800637,1.75 7.30993518,1.75 Z M13.5,10.75 L13.5,12.25 L4,12.25 L4,10.75 L13.5,10.75 Z" />
          </mask>
          <g mask="url(#transactions-mask)">
            <g transform="translate(-3.000000, -3.000000)">
              <rect id="Rectangle" fill="currentColor" x="0" y="0" width="24" height="24" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;
